const options = { style: 'currency', currency: 'BRL', minimumFractionDigits: 2 };
const parseToBRL = (value) => (value || '').toLocaleString('pt-BR', options);

export default parseToBRL;